module.exports = __webpack_public_path__ + "media/images/icons/pocitoveMapy-08df4e776835cd0f58a1248b0604d9a5.svg";